import { createJSONRequest } from '../../../api/create-request.js'

export const createConversation = () => createJSONRequest({
  method: 'POST',
  url: '/api/conversational-agent/conversations',
})

export const removeConversation = (conversationId: string) => createJSONRequest({
  method: 'DELETE',
  url: `/api/conversational-agent/conversations/${conversationId}`,
})

export const updateConversationTitle = (conversationId: string, title: string) => createJSONRequest({
  method: 'PUT',
  url: `/api/conversational-agent/conversations/${conversationId}/title`,
  data: {
    title: title,
  },
})

export const sendMessage = (message: string, conversationId: string) => createJSONRequest({
  method: 'POST',
  url: '/api/conversational-agent/messages',
  data: {
    message: message,
    sessionId: conversationId,
  },
})

export const getUserConversations = () => createJSONRequest({
  url: '/api/conversational-agent/conversations',
  method: 'GET',
})

export const getConversationMessages = (sessionId) => createJSONRequest({
  url: `/api/conversational-agent/${sessionId}/messages`,
  method: 'GET',
})
